
module dg.objects {
    import DG_DATA_TYPES = dg.restfulApi.DG_DATA_TYPES;


    export class DateService {

        constructor(
            private uibDatepickerPopupConfig,
            private uiDatetimePickerConfig,
            private $filter: ng.IFilterService,
            private moment: any) {

        }
        public getFormat(dataType) {
            return dataType == DG_DATA_TYPES.DateTime
                ? this.uiDatetimePickerConfig.dateFormat : this.uibDatepickerPopupConfig.datepickerPopup;
        }

        public dateTimeToUTC(date): Date {
            return new Date(this.$filter('date')(date, "MM/dd/yyyy HH:mm:ss", 'UTC'));
        }
       

    }
    angular.module('dg.objects')
        .service('dateService', DateService);
}